export function Input({
  field,
  type = "text",
  placeholder,
  className,
  isNumber = false,
  error,
  inputSize = "xl",
  testId,
}) {
  const sizeClasses = {
    sm: "py-1 text-sm",
    md: "py-1.5 text-sm",
    lg: "py-2 text-base",
    xl: "py-3 text-base",
  };

  const handleNumberInput = (e) => {
    if (!isNumber) return;
    const { key } = e;
    const allowedKeys = ["Backspace", "ArrowLeft", "ArrowRight", "Tab", "."];
    if (!allowedKeys.includes(key) && !/[0-9]/.test(key)) e.preventDefault();
    if (key === "." && e.target.value.includes(".")) e.preventDefault();
  };

  const handleNumberChange = (e) => {
    let value = e.target.value;
    if (isNumber) {
      if (value === "" || /^\d*\.?\d*$/.test(value)) {
        field.onChange(value);
      }
    } else {
      field.onChange(value);
    }
  };

  return (
    <input
      data-testid={testId}
      type={type}
      {...field}
      onKeyDown={handleNumberInput}
      onChange={handleNumberChange}
      placeholder={placeholder}
      className={`${className} outline-none placeholder:text-gray-400 text-md border-none w-full ${
        sizeClasses[inputSize]
      } ${
        error
          ? "ring-1 ring-red-300 rounded-md"
          : "hover:bg-slate-100 cursor-pointer transition duration-100"
      }`}
    />
  );
}
